import React from 'react';
import {
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { useSelector } from 'react-redux';
import { State } from '../redux/mainReducer';

/**
 * Drag&Drop-Hinweiskarte mit der Tabelle der erlaubten Datentypen (MIME-
 * Whitelist aus dem Redux-Store). Gemeinsame Basis für die Upload-Bereiche
 * (DocumentOverview, InvoiceTab, TaskDocuments) — #1200.
 */
export const AllowedFileTypesCard: React.FC = () => {
  const mimeTypeArray = useSelector(
    (state: State) => state.mimeTypeArray.storeAcademicTitle
  );

  return (
    <Card>
      <CardContent>
        <Typography variant='body2'>Dokument(e) hier reinziehen</Typography>
        Erlaubte Datentypen
        <br />
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Datentyp</TableCell>
              <TableCell>Datenendung</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {mimeTypeArray.map(mimeType => (
              <TableRow key={mimeType.idMIMEType}>
                <TableCell>{mimeType.MIMEType}</TableCell>
                <TableCell>{mimeType.FileExtension}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
};
